import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { SwiperComponent } from 'swiper/angular';
import { IDataDescriptionMapping, IDetailProduct, IProductDesc } from '../../Products.interface';
import { UtilitiesService } from '@services/utilities.service';
import { SwiperOptions } from 'swiper';
import { BehaviorSubject, Subscription } from 'rxjs';
import { BaseService } from '@services/base-service.service';
import { API } from '@config/constants/api.constant';
import { RewardSettingStatus } from '@config/enum/reward-setting.enum';
import { TableColumn } from '@shared/interface/table.interface';
import { BaseDatasource } from '@shared/base/base.datasource';
import { IDetailProductRewardSetting } from '@pages/reward-setting/reward-setting.interface';
import { BaseTableService } from '@shared/base/base-table-service.service';
import { PdfService } from '@services/pdf.service';
import { Sort } from '@angular/material/sort';
import { FilterService } from '@services/filter.service';
import { IGenericNameUrl } from '@shared/interface/generic';

@Component({
  selector: 'app-info-products',
  templateUrl: './info-products.component.html',
  styleUrls: ['./info-products.component.scss'],
})
export class InfoProductsComponent implements OnInit, OnDestroy {
  @ViewChild('swiper', { static: true }) swiper?: SwiperComponent;
  @Input() id: string;
  @Input() readDetail: boolean = true;
  @Output() productDescription = new EventEmitter<IProductDesc>();
  @Output() productData = new EventEmitter<IDetailProduct>();

  tableColumns: TableColumn[];
  displayedColumns: string[];
  rewardSettingList: IDetailProductRewardSetting[] = [];
  baseDatasource: BaseDatasource<IDetailProductRewardSetting>;

  bodyList: BehaviorSubject<IDataDescriptionMapping> = new BehaviorSubject<IDataDescriptionMapping>([]);
  subBodyList: IDataDescriptionMapping = [];
  STRING_CONSTANTS = STRING_CONSTANTS;
  dataDetails: BehaviorSubject<IDetailProduct | undefined> = new BehaviorSubject<IDetailProduct | undefined>(undefined);
  urlPreview: BehaviorSubject<string> = new BehaviorSubject<string>('');
  imageList: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  ASSET_ICON = STRING_CONSTANTS.ICON;
  ASSET_ILLUSTRATION = STRING_CONSTANTS.ILLUSTRATIONS;
  config: SwiperOptions = {
    slidesPerView: 3,
    spaceBetween: 50,
    navigation: false,
    pagination: { clickable: false },
  };

  private unsubscribe: Subscription[] = [];

  constructor(
    private baseService: BaseService,
    private ref: ChangeDetectorRef,
    public utilities: UtilitiesService,
    private baseTableService: BaseTableService<any>,
    private pdfService: PdfService,
    private filterService: FilterService
  ) {}

  ngOnInit(): void {
    const data = this.baseTableService.responseDatabase.subscribe((response) => (this.baseDatasource = response));

    this.getData();
    this.setData();
    this.setTableData();
    this.unsubscribe.push(data);
  }

  setTableData() {
    this.tableColumns = [
      { title: 'PERIODE', key: 'name' },
      { title: 'JUMLAH KUPON RETAILER', key: 'qty' },
      { title: 'STATUS', key: 'status' },
      { title: 'DIBUAT OLEH', key: 'created_by' },
      { title: 'TANGGAL DIBUAT', key: 'createdDate', isSortable: true },
      { title: 'DOKUMEN', key: 'actions' },
    ];

    this.displayedColumns = this.tableColumns.map((head) => head.key);
  }

  setData() {
    this.dataDetails.subscribe((data) => {
      if (data) {
        this.isLoading.next(false);
        const dataBody = [
          { label: 'Jenis Pestisida', value: data.pesticide_type },
          { label: 'Jenis Tanaman', value: data.plant_types },
          { label: 'Sasaran', value: data.pest_targets },
        ];
        this.bodyList.next(dataBody);
        this.ref.detectChanges();
        this.productData.emit(data);
        this.productDescription.emit({
          product_usage: data.product_usage,
          description: data.description,
        });
        this.rewardSettingList = this.rewardSettingList.concat(data.list_reward_period);
        this.baseDatasource.isFinishLoadingSubject.next(true);
      }
    });
  }

  getData() {
    const data = this.baseService.getData<IDetailProduct>(API.GET_DETAIL_BRAND + this.id).subscribe((res) => {
      if (res) {
        this.dataDetails.next(res.data);
      }
    });
    this.unsubscribe.push(data);
  }

  downloadDocument(document: IGenericNameUrl) {
    return this.pdfService.downloadPdf(document).subscribe((res) => res);
  }

  sortTable(param: Sort) {
    this.filterService.sortTable(param, this.tableColumns).then();
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  protected readonly RewardSettingStatus = RewardSettingStatus;
}
